import { IoInformationCircleOutline } from "react-icons/io5";

const MessageHeader = ({ room, setOpen }) => {
  return (
    <div className="flex items-center justify-between p-5 border-b border-gray-100">
      <div className="flex items-center">
        <div className="flex items-center justify-center h-7 w-7 rounded-full bg-gray-300">
          <span className="text-white text-sm">{room.name.charAt(0)}</span>
        </div>
        <p className="text-gray-400 text-lg ml-4">{room.name}</p>
      </div>
      <IoInformationCircleOutline
        className="text-blue-400 text-2xl cursor-pointer"
        onClick={() => setOpen()}
      />
    </div>
  );
};

export default MessageHeader;
